import ImagesLoaded from "imagesloaded";

export default {
    sortOnKey( array, key ){
        if( !array ) return array;
        array.sort( function( a, b ){
            if( a[ key ] > b[ key ] ){
                return 1;
            }
            if( a[ key ] < b[ key ] ){
                return -1;
            }

            return 0;
        } );
    },

    fakeLocation( url ){
        let fake = document.createElement( 'a' );
        fake.href = url;

        return fake;
    },

    imagesLoaded( ...args ){
        return ImagesLoaded( ...args );
    },

    raf( callback, fallback_delay = 0 ){
        return window.requestAnimationFrame ? window.requestAnimationFrame( callback ) : setTimeout( callback, fallback_delay );
    },

    clearRaf( id ){
        return window.cancelAnimationFrame ? window.cancelAnimationFrame( id ) : clearTimeout( id );
    },

    icon( name, klass = '' ){
        return `<svg class="icon icon-${ name } ${ klass }">
            <use xlink:href="#icon-${ name }"></use>
        </svg>`;
    }
}



// WEBPACK FOOTER //
// ./resources/js/framework/Utils.js